// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC12xXhhNNTO4vnMP7KQ4WjXOFv6Zn-JCY",
  authDomain: "metteredbilling.firebaseapp.com",
  projectId: "metteredbilling",
  storageBucket: "metteredbilling.firebasestorage.app",
  messagingSenderId: "196454901598",
  appId: "1:196454901598:web:53a37b35bc555873b711cf"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export default app;
